import { RefString } from "@tblabs/truffle";


export class AppState
{
    public Subtitle = new RefString();

    public SetSubtitle(subtitle: string): void
    {
        this.Subtitle.value = subtitle;
    }
}
